import { createSelector } from '@reduxjs/toolkit';

import { type LeagueType } from '@/common/types/league';
import { type ArenaOffersDto } from '@/common/types/shop/marketBoxes';

import { type RootState } from '../store';

import {
  arenaShownPopup,
  checkArenaDiscountTimer,
  checkTimeLeftArenaOffer,
  expiriesArenaDiscountTimer,
} from './lib';

const selectLeagueList = (state: RootState): LeagueType[] | null =>
  state.leagues.list;

const selectArenaPacks = (state: RootState): ArenaOffersDto[] =>
  state.shop.arenaOffers;

const selectLeagueByRank = createSelector(
  selectLeagueList,
  (_: RootState, leagueRank?: number): number | undefined => leagueRank,
  (leagueList, leagueRank): LeagueType | undefined => {
    if (!leagueList) {
      return;
    }

    if (leagueRank) {
      const league = leagueList.find(({ nextLeagueId, prevLeagueId }) => {
        const currentRank = nextLeagueId
          ? nextLeagueId - 1
          : prevLeagueId
            ? prevLeagueId + 1
            : null;

        return leagueRank === currentRank;
      });

      return league;
    } else {
      return leagueList[0];
    }
  },
);

const checkDiscountTimer = createSelector(
  selectArenaPacks,
  checkArenaDiscountTimer,
);

const expiriesDiscountTimer = createSelector(
  selectArenaPacks,
  expiriesArenaDiscountTimer,
);

const arenaShownPopupCheck = createSelector(selectArenaPacks, arenaShownPopup);
const timeLeftArenaOffer = createSelector(
  selectArenaPacks,
  checkTimeLeftArenaOffer,
);

export {
  arenaShownPopupCheck,
  checkDiscountTimer,
  expiriesDiscountTimer,
  selectLeagueByRank,
  timeLeftArenaOffer,
};
